import { useContext } from 'react';
import { HeaderContext } from '/views/sections/header/header';

export const useHeader = () => useContext(HeaderContext);

export default useHeader;
